import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class MinorDistributionInheritanceAgeType extends Enum {
  static MAJORITY = {
    key: 'majority',
    get value() {
      return Lang.t('vaultdistributionsetting.at-majority');
    }
  };

  static SPECIFIC_AGE = {
    key: 'specific_age',
    get value() {
      return Lang.t('vaultdistributionsetting.at-specific-age');
    }
  };

  static MULTIPLE_SPECIFIC_AGES = {
    key: 'multiple_specific_ages',
    get value() {
      return Lang.t('vaultdistributionsetting.at-multiple-ages');
    }
  };
}
